import { $api } from "../generated/client";

export default function useSizingConfig(shopId: string) {
	return $api.useQuery("get", "/shops/{shopId}/sizing/config", {
		params: { path: { shopId } },
		enabled: !!shopId,
	});
}
